import { graphql } from '../gql';

export const getTableauToken = graphql(`
  query GetTableauToken($userId: ID!) {
    getTableauToken(tableauDomain: VendorReportFFR) {
      token
      error {
        code
        message
      }
    }
    getUser(id: $userId) {
      user {
        uuid
      }
    }
  }
`);
